import React, { useState } from "react";
import "layout/Menu/Mobile-menu.scss";
import Logo from "layout/Header/Logo/Logo";
import { ReactComponent as IconHamburger } from "assets/images/icons/hamburger.svg";
import { ReactComponent as CloseIcon } from "assets/images/icons/close.svg";
import TopMenuList from "layout/Menu/TopMenuList";
import MainMenuList from "layout/Menu/MainMenuList";

function MobileMenu() {
  const [isActive, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!isActive);
  };

  return (
    <>
      <div className="hamburger" onClick={ handleToggle }>
        <IconHamburger/>
        Menu
      </div>

      <div className={ `mobile-menu ${ isActive && "mobile-menu--opened" }` }>
        <div className="mobile-menu__header">
          <div className="mobile-menu__logo">
            <Logo/>
          </div>

          <div onClick={ handleToggle } className="mobile-menu__close">
            sluiten
            <div className="mobile-menu__close-icon">
              <CloseIcon/>
            </div>
          </div>
        </div>

        <ul className="mobile__menu mobile__menu--top">
          <TopMenuList onClick={ handleToggle }/>
        </ul>

        <ul className="mobile__menu mobile__menu--main">
          <MainMenuList onClick={ handleToggle }/>
        </ul>
      </div>

      <div className={ `mobile-menu-mask ${ isActive && "mobile-menu-mask--show" }` } onClick={ handleToggle }></div>
    </>
  );
}

export default MobileMenu;
